import React from "react";
import ReactEcharts from "echarts-for-react"; 
function GraphAleasRapport({myDataMoy2D, myDataMax2D, myDataMoy4D, myDataMax4D, dataType, type, print}) {  
  const myDataMaxDif2D = type==="Max" ? [0, myDataMax2D[1]-myDataMax2D[0], myDataMax2D[2]-myDataMax2D[0], myDataMax2D[3]-myDataMax2D[0], myDataMax2D[4]-myDataMax2D[0], myDataMax2D[5]-myDataMax2D[0], myDataMax2D[6]-myDataMax2D[0]] : myDataMax2D
  const myDataMoyDif2D = type==="Moy" ? [0, myDataMoy2D[1]-myDataMoy2D[0], myDataMoy2D[2]-myDataMoy2D[0], myDataMoy2D[3]-myDataMoy2D[0], myDataMoy2D[4]-myDataMoy2D[0], myDataMoy2D[5]-myDataMoy2D[0], myDataMoy2D[6]-myDataMoy2D[0]] : myDataMoy2D
  const myDataMaxDif4D = type==="Max" ? [0, myDataMax4D[1]-myDataMax4D[0], myDataMax4D[2]-myDataMax4D[0], myDataMax4D[3]-myDataMax4D[0], myDataMax4D[4]-myDataMax4D[0], myDataMax4D[5]-myDataMax4D[0], myDataMax4D[6]-myDataMax4D[0]] : myDataMax4D
  const myDataMoyDif4D = type==="Moy" ? [0, myDataMoy4D[1]-myDataMoy4D[0], myDataMoy4D[2]-myDataMoy4D[0], myDataMoy4D[3]-myDataMoy4D[0], myDataMoy4D[4]-myDataMoy4D[0], myDataMoy4D[5]-myDataMoy4D[0], myDataMoy4D[6]-myDataMoy4D[0]] : myDataMoy4D
  
  const getOptions = () => {
    let options = {
      legend: {
        data: type==="Max" ? ['Maximum 2°C','Maximum 4°C' ] : ['Moyenne 2°C','Moyenne 4°C' ],
        textStyle: {
          fontSize: 14, // Ajustez la taille de la police de la légende selon vos besoins
        },
      },
      grid: {
        top: '18%',
        left:'11%',
        right:'13%',
      },
      xAxis: {
        type: 'category',
        data: ['2020','2025','2030','2035', '2040', '2045', '2050'],
        name: 'Risques',
        nameLocation: 'middle', // Place le nom de l'axe au centre sous l'axe
        nameGap: 30,
        nameTextStyle: {
          fontSize: 16 // Ajustez la taille de la police selon vos besoins
        },
        axisLabel: {
          fontSize: 16, // Ajustez la taille de la police des valeurs de l'axe Y selon vos besoins
        }
      },
      yAxis: {
        type: 'value',
        name: 'Perte en %',
        nameTextStyle: {
          fontSize: 16 // Ajustez la taille de la police selon vos besoins
        },
        axisLabel: {
          fontSize: 16 // Ajustez la taille de la police des valeurs de l'axe Y selon vos besoins
        }
      },
      series: [
        {
          name: 'Maximum 2°C',
          data: dataType === 'Diff' ? myDataMaxDif2D : myDataMax2D,
          type: 'line',
          smooth: true,
          symbolSize: 10,
          lineStyle: {
            width: 2, // Ajustez la largeur de la ligne selon vos besoins
            type: 'dashed',
          },
          itemStyle: {
            color: 'red'
          }
        },
        {
          name: 'Moyenne 2°C',
          data: dataType === 'Diff' ? myDataMoyDif2D : myDataMoy2D,
          type: 'line',
          smooth: true,
          symbolSize: 10,
          lineStyle: {
            width: 2, // Ajustez la largeur de la ligne selon vos besoins
            type: 'dashed',
          },
          itemStyle: {
            color: '#e6d000'
          }
        },
        {
          name: 'Maximum 4°C',
          data: dataType === 'Diff' ? myDataMaxDif4D : myDataMax4D,
          type: 'line',
          smooth: true,
          symbolSize: 10,
          itemStyle: {
            color: '#870000'
          }
        },
        {
          name: 'Moyenne 4°C',
          data: dataType === 'Diff' ? myDataMoyDif4D : myDataMoy4D,
          type: 'line',
          smooth: true,
          symbolSize: 10,
          itemStyle: {
            color: '#9e8f01'
          }
        }
      ]
    };

    return options;
  };
  

    return (
      <div style={{marginBottom:print === true ? "10px" : "20px", width: print === true ? '470px' : '98%', height: print === true ? '550px' :  '450px', marginTop:print === true ? '10px' : '30px'}}>
        <ReactEcharts option={getOptions()} style={{ height: '100%', width:'100%' }} />
    </div>
  
  );
}

export default GraphAleasRapport;
  